var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Collapse as ChakraCollapse, } from "@chakra-ui/react";
/**
 * The Collapse component is used to create regions of content that can
 * expand/collapse with a simple animation. It helps to hide content that's
 * not immediately relevant to the user.
 *
 * This component leverages react-animate-height.
 */
export const Collapse = forwardRef((_a, ref) => {
    var { isOpen } = _a, rest = __rest(_a, ["isOpen"]);
    return React.createElement(ChakraCollapse, Object.assign({}, rest, { ref: ref, animateOpacity: true, in: isOpen }));
});
Collapse.displayName = "Collapse";
export default Collapse;
//# sourceMappingURL=Collapse.js.map